// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"534fca7d","404":"53932a07"}[chunkId] + ".chunk.js";
};